<template>
    <div class="list">
        <NavBar></NavBar>
    <!-- <van-pull-refresh v-model="isLoading" success-text="刷新成功" @refresh="onRefresh"> -->
        <van-col span='24' style="font-size:16px;font-weight:bold;text-align:center;padding-top:7px">{{thatName}}</van-col>
        <van-cell title="基本信息" :value="completionDate" />
        <div class="card_content">
            <div class="card_son">
                <van-col span='24' style="font-size:13px">维修项目名称：{{obj.reqName}}</van-col>
                <van-col span='24' style="font-size:13px;margin:7px 0">维修项目类型：{{obj.projectType=='1'?'正常项目':obj.projectType=='2'?'应急项目':''}}</van-col>
                <van-col span='24' style="font-size:13px">分摊方式：{{obj.marginType}}</van-col>
                <van-col span='24' style="font-size:13px;margin:7px 0">维修类别：{{obj.maintainTypeName}}</van-col>
                <van-col span='24' style="font-size:13px">申请单位：{{obj.orgType=='1'?obj.orgReqName:obj.orgType=='2'?obj.orgOwner:''}}</van-col>
                <van-col span='24' style="font-size:13px;margin:7px 0">施工单位：{{obj.orgConstructionName}}</van-col>
                <van-col span='24' style="font-size:13px">竣工日期：{{completionDate}}</van-col>
                <van-col span='24' style="font-size:13px;margin:7px 0">决算金额（元）：{{obj.finalSum}}</van-col>
                <van-col span='24' style="font-size:13px">分摊总户数：{{obj.allUser}}</van-col>
                <van-row gutter="20">
                    <van-col span='12' style="font-size:13px;margin:7px 0">分摊总面积(㎡)：{{obj.allArea}}</van-col>
                    <van-col span='12' style="color:blue;font-size:13px;margin:7px 0;text-align:right" @click="openShare">查看分摊清册</van-col>
                </van-row>
            </div>
        </div>
        <!-- 勘查图片 -->
        <van-cell value="勘查图片" />
        <div v-if="isShow">
            <van-empty image="error" description="暂无图片" />
        </div>
        <!-- <div v-if="!isShow" class="card_content">
            <div class="card_son">
                <div v-for="(item,index) in imgList" :key="index" style="margin-bottom:10px">
                    <van-image  width="100%" :src="item" @click="openImg(index)"/>
                </div>
            </div>
        </div> -->
        <!-- 查看图片新的写法 -->
        <div v-if="!isShow" class="card_content">
            <div class="card_son">
                <div v-for="(item,index) in imgList" :key="index" style="margin-bottom:10px">
                    <van-image  width="100%" :src="item" @click="openImg(index)">
                        <van-image-preview v-model:show="show2" :images="imgList" :startPosition='startPosition'>
                        </van-image-preview>
                    </van-image>
                </div>
            </div>
        </div>
        <!--公示说明  -->
        <van-cell value="公示说明" />
        <div class="card_content" style="margin-bottom:45px">
            <div class="card_son">
                <van-col style="font-size:13px;text-indent:2em;line-height:20px" span='24'>由{{obj.orgType=='1'?obj.orgReqName:obj.orgType=='2'?obj.orgOwner:''}}申请提交的《{{obj.reqName}}》经由主管社区审批研究，该维修项目符合维修资金应急审批条件，予以审批通过，并报备物业管理部门。现已维修竣工，将维修结果予以公示。</van-col>
            </div>
        </div>
        <!-- 分摊清册弹框 -->
        <van-dialog v-model:show="inmation" title="维修资金预分摊清册" show-cancel-button :show-confirm-button='false'>
            <div style="padding:10px 15px;font-size:14px;height:250px;overflow:auto">
                <van-col span='24'>汇总信息</van-col>
                <van-col span='24' style="margin:15px 0">总户数：{{obj.allUser}}</van-col>
                <van-col span='24'>业主自交户数：{{obj.selfSum}}</van-col>
                <van-col span='24' style="margin:15px 0">预算金额(元)：{{obj.budgSum}}</van-col>
                <van-col span='24'>自交金额(元)：{{obj.selfAmount}}</van-col>
                <van-col span='24' style="margin:15px 0">分摊面积(㎡)：{{obj.allArea}}</van-col>
                <table border="1" cellspacing='0' cellpadding='10' style="width:100%">
                    <tr>
                        <th>房屋坐落</th>
                        <th>分摊金额</th>
                    </tr>
                    <tr style="font-size:12px;" v-for="item in list" :key="item">
                        <td>{{item.houseSite}}</td>
                        <td style="text-align:center">{{item.assiAmount}}元</td>
                    </tr>
                </table>
            </div>
        </van-dialog>
        <!--  -->
    <!-- </van-pull-refresh> -->
    </div>
</template>

<script>
import axios from 'axios'
import { ImagePreview } from "vant";
export default {
    components: {
        [ImagePreview.Component.name]: ImagePreview.Component,
    },
    data(){
        return {
            startPosition:'',
            math:'',
            show2:false,
            isShow:false,
            thatName:'',
            Url:'',
            obj:{},
            id:'',
            list:[],
            inmation:false,
            isLoading:false,
            imgList:[],
            completionDate:''
            // imgList:[
            //     'https://img.yzcdn.cn/vant/cat.jpeg',
            //     "https://img.yzcdn.cn/vant/apple-2.jpg",
            //     "https://img.yzcdn.cn/vant/apple-3.jpg",
            //     "https://img.yzcdn.cn/vant/apple-4.jpg",
            // ],
        }
    },
    /**
     * 在切换路由或者关闭路由的时候关闭预览图片的遮罩
     */
    /**
     * 在这里要判断一下图片是否关闭和弹框是否关闭 没关闭的话先关闭图片和弹框在返回路由
     */
    beforeRouteLeave(to,from,next){
        this.$nextTick(()=>{
            if(this.inmation||this.show2){
                this.show2 = false
                this.inmation = false
                next(false)
            }else if(!this.show2||!this.inmation){
                next(true)
            }
        })
    },
    // beforeRouteLeave(to,from,next){
    //     this.$nextTick(()=>{
    //         if(this.math=='1'){
    //             this.instance_after.close()
    //         }
    //         if(this.inmation){
    //             this.inmation = false
    //         }
    //     })
    //     next()
    // },
    methods:{
        /**
         * 点击图片预览
         */
        openImg(index){
            // this.math = '1'
            // console.log(index)
            // this.instance_after = ImagePreview({
            //     images:this.imgList,
            //     startPosition: index,//点击的索引打开就是哪个图片
            //     closeable: true,
            //     closeOnPopstate:true,
            // });
            this.show2 = true
            this.startPosition = index
        },
        /**
         * 查看分摊清册
         */
        openShare(){
            this.inmation = true;
            let data = {
                id:this.id,
                pageNum:1,
                pageSize:100
            }
            this.$postQuery('/WeChat/getApportionmentList', data).then((response) => {
                console.log(response)
                if(response.code==200){
                    this.list = response.data.list
                }
            })
        },
        ShowEmergency(){
            let data = {
                id:this.id
            }
            this.$postQuery('/WeChat/getReqDetailById', data).then((response) => {
                console.log(response)
                if(response.code==200){
                    this.obj = response.data
                    response.data.surveyFileList.forEach((item)=>{
                        // console.log(item,'11111111111')
                        //URL是从axios里面获取到的
                        // item = this.Url+item http://ytwyw.cn
                        // item =  'http://192.168.31.101:9004'+item
                        item = 'http://nhzjwxzj.weihai.cn'+item
                        // item =  'http://ytwyw.cn'+item
                        this.imgList.push(item)
                        console.log(this.imgList)
                    })
                    console.log([...this.imgList])
                    if(this.imgList.length==0){
                        this.isShow=true
                    }
                }
            })
        }
    },
    created(){
        this.Url = axios.defaults.baseURL
        this.thatName = this.$route.query.thatName
        this.id = this.$route.query.id
        this.completionDate = this.$route.query.completionDate
        if(this.completionDate){
            this.completionDate = this.completionDate.substring(0,10)
        }
        this.ShowEmergency();
        // console.log(axios.defaults.baseURL,'11111')
    }
}
</script>

<style scoped>
.list {
    margin-top: 46px;
}
.card_content{
    padding: 0 10px 0px 10px;
}
.card_son{
    border: 1px solid #ebedf0;
    padding: 10px;
    box-shadow: 2px 3px 12px #ebedf0;
    margin-bottom:10px;
}
</style>